import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { ChangeOffer, Offer, OffersQuery } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class CustomerSupplierOffersApi {
  getOffersAsync(query: OffersQuery): Promise<Page<Offer>> {
    return api.get<Page<Offer>>(
      `/v1/supplier/offers`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  createOfferAsync(model: ChangeOffer): Promise<string> {
    return api.post<string>(`/v1/supplier/offers`, model, getRequestConfig())
      .then(x => x.data);
  }

  cancelOffer(id: string) {
    return api.put<any>(`/v1/supplier/offers/${id}/cancel`, null, getRequestConfig());
  }

  deleteOffer(id: string): Promise<any> {
    return api.delete(`/v1/supplier/offers/${id}`, getRequestConfig());
  }
}

export default new CustomerSupplierOffersApi();